import { useMemo } from "react";
import { Navigate } from "react-router-dom";
import WorkspaceShell from "./WorkspaceShell";
import WorkspaceSectionBody from "./WorkspaceSectionBody";
import {
  WORKSPACE_THEME,
  canAccessTeamHub,
  getTeamHubSections,
  getWorkspaceRole,
} from "./workspaceConfig";

export default function TeamHubPage() {
  const role = getWorkspaceRole();
  const sections = useMemo(() => getTeamHubSections(role), [role]);

  if (!canAccessTeamHub(role)) {
    return <Navigate to="/my-desk" replace />;
  }

  return (
    <WorkspaceShell
      eyebrow="Lead & admin"
      title="Team Hub"
      subtitle="CSR and Chat Support in one place: today, assign, set targets, approvals, and team performance."
      sections={sections}
      accent={WORKSPACE_THEME.primary}
    >
      {({ active, go }) =>
        active ? (
          <WorkspaceSectionBody componentKey={active.component} onGo={go} />
        ) : null
      }
    </WorkspaceShell>
  );
}
